import { getUnenrollmentSection } from 'automation-ui-canvas/containers/settings/v2/SettingsConfigurations';
import SettingsSection from 'automation-ui-canvas/containers/settings/v2/SettingsSection';
import { useQuery } from 'data-fetching-client';
import { useHistory, useLocation } from 'react-router-dom';
import { GET_SFDC_PORTAL_SETTINGS_QUERY } from 'automation-ui-canvas/queries/SalesforceEnabledPortalSettingQuery';
import { Map as ImmutableMap } from 'immutable';
import { useRef } from 'react';
import classicSettingsTranslations from 'i2l?query=sporks!automation-ui-canvas/lang/settings/en.lyaml';
import { compose } from 'redux';
import LazyLangLoaderDecorator from 'automation-ui-i18n/LazyLangLoaderDecorator';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const UnenrollmentSettingsSection = ({
  flow,
  readOnly,
  suppressionFilters,
  suppressionLists,
  goalFilters,
  enrollmentList,
  onChange,
  classicEnrollmentSettings,
  isListeningSettingDisabled,
  areLangStringsLoading
}) => {
  const location = useLocation();
  const history = useHistory();
  const refsById = useRef(ImmutableMap());
  const {
    data: salesforcePortalSetting
  } = useQuery(GET_SFDC_PORTAL_SETTINGS_QUERY);
  const {
    modules
  } = getUnenrollmentSection({
    isClassicWorkflow: flow.getIsClassicWorkflow()
  });
  if (areLangStringsLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SettingsSection, {
    location: location,
    salesforcePortalSetting: salesforcePortalSetting && salesforcePortalSetting.portalSettings,
    history: history,
    flow: flow,
    settings: {
      suppressionFilters: suppressionFilters.setting,
      classicEnrollmentSettings: classicEnrollmentSettings.setting,
      goalFilters: goalFilters.setting,
      isListeningSettingDisabled,
      suppressionLists: suppressionLists.setting,
      enrollmentList: enrollmentList.setting
    },
    onChange: onChange,
    readOnly: readOnly,
    id: "unenrollmentSettings",
    title: /*#__PURE__*/_jsx(_Fragment, {}),
    modules: modules,
    hasBorder: true,
    use: "unstyled",
    scrollTo: () => {},
    refsById: refsById
  });
};
export default compose(LazyLangLoaderDecorator([classicSettingsTranslations]))(UnenrollmentSettingsSection);